import { Page } from '../../domain/page';
import { AppMode } from '../appStore';

export const getExtensionModeState = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('mode');

  if (mode === AppMode.Salesforce) {
    const trackingSectionName = urlParams.get('trackingSectionName');
    const domain = urlParams.get('domain');
    return {
      mode: AppMode.Salesforce,
      companyDomain: domain as string,
      url: String(window.location),
      isOpen: true,
      page: Page.Company,
      trackingSectionName: trackingSectionName as string,
    };
  }

  if (mode === AppMode.ProSidebar) {
    const trackingSectionName = urlParams.get('trackingSectionName');
    return {
      mode: AppMode.ProSidebar,
      page: Page.Home,
      isOpen: false,
      trackingSectionName: trackingSectionName as string,
    };
  }

  if (mode === AppMode.Standalone) {
    const domain = urlParams.get('domain');
    return {
      mode: AppMode.Standalone,
      companyDomain: domain as string,
      url: String(window.location),
      isOpen: true,
      page: Page.Company,
    };
  }

  return {
    mode: AppMode.Extension,
    isOpen: false,
    page: Page.Home,
  };
};
